/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: 审核公共组件
 * 使用说明: 参考 sw-work-flow 配置应用说明文档
 * 更新说明:
 */
import { Component, OnInit, Input, Output, EventEmitter, ComponentFactoryResolver } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RefFileObjectService } from 'src/app/librarys/serves/public/ref-file-object.service';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwMaskService } from '../../basic-components/sw-mask/sw-mask.service';
import { SwFlowChartComponent } from '../sw-flow-chart/sw-flow-chart.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { BdpEnum } from 'src/app/areas/bdp/serves/bdp-enum';
import { SwOperatorModalComponent } from './sw-operator-modal/sw-operator-modal.component';
import { SwApprovalModalComponent } from './sw-approval-modal/sw-approval-modal.component';
import { SwMessageConfirmService } from '../../basic-components/sw-massage-confirm/sw-message-confirm.service';
import { SwAddressBookComponent } from '../../basic-components/sw-address-book/sw-address-book.component';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
declare var $: any;


/**
 * 公共审核组件  sw-work-flow
 */
@Component({
  selector: 'sw-work-flow',
  templateUrl: './sw-work-flow.component.html',
  styleUrls: ['./sw-work-flow.component.css']
})
export class SwWorkFlowComponent implements OnInit {


  /**
   * @ignore
   */
  constructor(
    private User: GetUserModelService, //获取用户信息
    private todos: ProcessToDosService,  //获取待办信息
    public box: SwMassageBoxService, //提示信息
    private tagServe: SwTabService, //tab页服务
    private http: SwHttpClientService, //http请求
    private activedRouter: ActivatedRoute, //获取当前路由地址
    private fileService: RefFileObjectService,   //附件服务
    private systemId: SystemIdService, 
    private create:SwCreateModalComponentService,
    private swMaskService:SwMaskService,  //遮罩层服务
    private router: Router,
    private cfr: ComponentFactoryResolver,
    private swMessageConfirmService:SwMessageConfirmService,  //动态创建确认框的服务
    private bdpService: BdpService, //请求服务
  ) {}

  /**
   * 表单ID,路由跳转到业务页面时,传递的param参数,都会直接从这个输入属性中过来  
   * 有两种情况: 
   * 1. 正常使用工作流组件传入的输入属性  其中包括:  businessKey  taskId  procInstId
   * 2. 通过指令创建的工作流组件, 传入的formId属性, 就是 businessKey
   */
  @Input() fromId: any 

  /**
   * 将操作结果抛出给业务,让其修改业务数据状态，或对数据进行伪删除操作 ：
   * complete(是否完成流程): 0  --> 未完成, 1 --> 完成 ;  
   * code: 1 --> 通过 ,  2 --> 退回 , 3 --> 拒绝 , 4 -->  撤销 ， -99--此流程为删除流程或修改流程，业务方什么都不做， -999--此流程是删除流程，业务方做伪删除操作
   * status: 1 --> 审核中（此时 complete=0，code=1 或 code=2） , 2 --> 通过（此时 complete=1， code =1） , 3 --> 审核中（此时 complete=0， code =2）, 4 --> 拒绝（此时 complete=1. code =3）, 5 --> 撤销 （complete=1. code =4）， 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
   * 
   * 对code/status 值为 991 或 992 或 999 的说明：
   * 1. 删除流程（属于不可编辑流程，不能改变业务数据状态，所以code和status不像普通流程那样，只有 991 或 992 或 999 三种情况，只有在流程结束且通过之后，才能将业务数据伪删除）：
   * 999 --> 流程点击退回 / 流程被拒绝 / 流程被撤销时，业务方此时什么都不做 ； 
   * 991 --> 点击通过按钮， 流程未结束 ，此时自定义表单需要更新业务数据
   * 992 --> 点击通过按钮， 流程已结束 ，此时自定义表单需要更新业务数据，且进行伪删除操作
   * 
   * 2. 修改流程（属于不可编辑流程，不能改变业务数据状态）：
   * 999 --> 流程点击退回 / 流程被拒绝 / 流程被撤销时，业务方此时什么都不做 ； 
   * 991 --> 点击通过按钮， 流程未结束 ，此时自定义表单需要更新业务数据
   */
  @Output() voted = new EventEmitter(); 

  /**
   * 查询到节点配置之后,将其中的变量配置(type =2) 的配置抛出
   */
  @Output() votedNodeConfig = new EventEmitter(); 

  /**
   * 查询到节点配置之后,将其中的变量配置(type =2 && name='BusinessInput') 的表单输入结果抛出
   */
  @Output() votedNodeConfigResult = new EventEmitter(); 

  /**
   * 自定义传入属性(通过审核保存值)
   */
  @Input( ) variables:any={};

  /**
   * 是否能显示审批区域,此时只能显示相关推荐,默认只显示审批区域
   */
  @Input() canShowWorkFlow:boolean = true

  /**
   * 是否能显示相关推荐区域,此时只能显示审批区域,默认只显示审批区域, 如果 canShowWorkFlow canShowRecommend 同时为false,请直接将工作流组件隐藏
   */
  @Input() canShowRecommend:boolean = false

  /**
   * 展示相关推荐区域后，是否传入自定义的相关推荐的头部，没有传就使用默认的，传了，就不使用默认的
   * @ignore 
   */
  @Input() hasCustomRecommendHeader:boolean = false

  /**
   * 默认是true--直接使用工作流组件, 为false--使用工作流指令创建的,这种情况下不显示按钮组
   * @ignore
   */
  isHide:boolean = true 

  /**
   * 1 为tab 2为弹出框
   * @ignore
   */
  openType:number=1

  /**
   * 工作流上传附件策略
   * @ignore
   */
  fileCode: string = 'CMS_WORKFLOW_FILE' 

  /**
   * 工作流上传附件组件查看状态
   * @ignore
   */
  fileIsReadOnly: boolean = false  

  /**
   * @ignore
   * 工作流上传附件组件的附件表id , this.businessId = this.procData.taskId， 但是历史审核记录中的审核附件上传的业务id是审核记录中的 taskId
   */
  businessId: string  

  /**
   * 当前用户属性
   * @ignore
   */
  userModel: any; 

  /**
   * @ignore
   * 历史审核数据
   */
  workFlowModel: any = []; 

  /**
   * @ignore
   * 模态框id
   */
  ids: string; 

  /**
   * 流程图路径
   * @ignore
   */
  pngUrl: any; 

  /**
   * 备注
   * @ignore
   */
  message: any;

  /**
   * 当前路径
   * @ignore
   */
  pathname = ""; 

  /**
   * 工作流上传的附件信息
   * @ignore
   */
  workFlowFiles: any  

  /**
   * 工作流隐藏时的定位--'0'的时候出现， '-140%' 的时候收起
   * @ignore 
   */
  @Input() right:string = '0'

  /**
   * 是否可以操作审核组件 ,如果没有,所有操作按钮都不能显示,默认没有
   * @ignore
   */
  hasTaskId:boolean = false  

  /**
   * 是否有驳回按钮,默认没有,只有从待办过来的且不是发起人才有
   * @ignore
   */
  canUnTask:boolean = false 

  /**
   * 是否有跳转到编辑业务的按钮,默认没有,根据 sid , firstSid , flowType 来确定
   * @ignore
   */
  canToEdit:boolean = false 

  /**
   * 是否有跳转到编辑业务的按钮,能够重新提交
   * @ignore
   */
  canSubmit:boolean = false

  /**
   * 流程的状态,有 审核通过 , 拒绝 ,已撤销, 审核中 , 默认是 审核中, 此值来决定是否显示流程结束的图标
   * @ignore
   */
  procStatus:string = "审核中"  

  /**
   * 流程的名称,显示在工作流组件的头部
   * @ignore
   */
  processTitle:string  

  /**
   * 该节点是否能够进行 子流程常量配置,默认不能
   * @ignore
   */
  canSetAppr:boolean = false  

  /**
   * 该节点是否配置了业务附件上传（在节点变量中配置， name值必须是 BusinessIdFileUpload ， 可配置多个）
   * @ignore
   */
  businessFileCodes:any[] = []  

  /**
   * 该节点是否配置了业务表单（在节点变量中配置， name值必须是 BusinessInput ， 可配置多个）
   * @ignore
   */
  businessInputs:any[] = []

  /**
   * 该节点配置了业务表单后，用户所输入的值
   * @ignore
   */
  businessInputValue:any = {}
  
  /**
   * 该节点配置了业务附件上传之后的业务id , this.anotherBusinessId = this.procData.businessId
   * @ignore
   */
  anotherBusinessId:string = ""

  /**
   * 业务附件上传的附件信息
   * @ignore
   */
  businessFiles: any = {}  

  /**
   * 审核组件中的常量配置列表
   * @ignore
   */
  approvalPageList:any[] = []  
  
  /**
   * 根据 taskId 和 procInstId 去查询到的最新的 sid 相关的结果 ,其中包含 taskId (最新的,不要使用formId中的taskId), procInstId(与formId中的一样), keyWord  和 businessId (可以组成 businessKey, 就与 formId中的 businessKey 一样了)
   * @ignore
   */
  procData:any

  /**
   * 该节点是否能够进行 指定执行人常量配置,默认不能,如果能配置的话,就是必填项
   * @ignore
   */
  canSetOperator:boolean = false 

  /**
   * 指定执行人的下拉多选框用户列表的id组成的数组--从常量配置中查出来的
   * @ignore
   */
  operatorIds:any[] = []

  /**
   * 点击的审核操作按钮是哪一个
   * @ignore
   */
  action:string

  /**
   * 历史记录中的pdId
   * @ignore
   */
  procDefId:string

  /**
   * 能否显示撤销按钮
   * @ignore
   */
  canRevocate:boolean = false
  
  /**
   * 能否再次点击,默认可以,当点击查看流程图之后将之置为false, 不能再次连续点击查看流程图以及其他操作按钮
   * @ignore
   */
  canClickAgain:boolean = true

  /**
   * 是展示相关推荐还是展示审批区域,切换用
   * @ignore
   */
  recOrWork:string = "workFlow"

  /**
   * 流程数据异常提醒
   * @ignore
   */
  procDataErrorTip:string = ""

  /**
   * 包容性网关用户（仅郑州）
   * @ignore
   */
  inclusiveGateWayUser:boolean = false

  /**
   * 审核组件是否禁用--当历史审核记录没有加载完成之前，操作按钮不能点击，都在报错，且历史审核记录区域有正在加载的样式
   * @ignore
   */
  disabled:boolean = true

  /**
   * 节点的常量配置中的抄送人常量配置，如果有值，就出现选择抄送人按钮
   * @ignore
   */
  receiver:string = ""

  /**
   * 选择的抄送人信息数组 [{id:xxx , text:xxx}]
   * @ignore
   */
  receiverUsers:any[] = []

  /**
    * 是否有撤回按钮
    * @ignore
    */
   canRevoke:boolean = false

   /**
    * 查询到的所有用户信息，用于展示选中抄送人之后显示中文
    * @ignore
    */
   allUsers:any[] = []

  /**
   * @ignore
   */
  ngOnInit() {
    //先判断是否能显示工作流
    if(this.canShowWorkFlow == false){
      //不显示工作流,只显示相关推荐
      this.recOrWork = "recommend"
    } else {  //只有在能展示工作流的时候才需要进行下面的代码,避免查看页面数据不全报错
      //正常使用时的 formId是个对象,其中有 procInstId
      let postUrl 
      if(this.fromId && this.fromId.procInstId){
        postUrl = environment.activitiWebAPI + `swActivitiTaskRecord/queryCurrentSidBytaskIdAndPid?pid=${this.fromId.procInstId}`
      } else if(this.fromId){
        //指令创建的工作量,formId就是 businessKey 或者是 procInstId
        if(this.fromId.indexOf('procInstId') != -1){
          // 如果是根据 procInstId 去查，先找到 procInstId
          let pidArr = this.fromId.split(':')
          let procInstId = pidArr[1]
          postUrl = environment.activitiWebAPI + `swActivitiTaskRecord/queryCurrentSidBytaskIdAndPid?pid=${procInstId}`
        } else {
          // 否则就根据 businessKey 去查
          postUrl = environment.activitiWebAPI + `swActivitiTaskRecord/queryCurrentSidByBusinessKey?businessKey=${this.fromId}`
        }
        // postUrl = environment.activitiWebAPI + `swActivitiTaskRecord/queryCurrentSidByBusinessKey?businessKey=${this.fromId}`
      }
      //获取所有用户信息，为抄送人功能显示用户名服务的
      this.getUser()

      this.http.Post(postUrl,{}).subscribe(res=>{
        if(res && res.code == 200){
          if(res.data){
            //如果数据获取了
            this.procData = res.data 
            this.openType = this.procData.openType
            //如果是正常使用的工作量组件,就去判断按钮是否显示
            if(this.procData && this.fromId.procInstId){
              //1. taskId 和 sid 都存在 -->  流程没有结束,可能有审核操作
              //2. taskId 和 sid 都不存在  -->  流程已经结束,一定没有审核操作
              this.procData.businessKey = this.procData.keyWord + ":" + this.procData.businessId
              this.hasTaskId = this.procData.taskId ? true : false  //taskId只要存在,就说明可以操作审核按钮

              // 3. 判断能否展示撤回按钮通过接口判断
              if(this.isHide && this.fromId.procInstId){
                this.http.Post(environment.activitiWebAPI + "activitiRunTime/canTaskRevoke", {procInstId:this.fromId.procInstId}).subscribe(result => {
                  if(result && result.code == 200){
                    //能展示撤回按钮
                    this.canRevoke = true
                  }
                })
              }

              // 4. 判断能否展示退回按钮通过接口判断
              if(this.isHide && this.hasTaskId){
                let param = {
                  taskId: this.procData.taskId,
                }
                this.http.Post(environment.activitiWebAPI + "activitiRunTime/checkGoBack", param).subscribe(result => {
                  if(result && result.code == 200){
                    //能展示退回按钮
                    this.canUnTask = true
                  }
                })
              }

              //默认不能配置子流程
              //流程还没有结束
              //sid 存在说明流程没有结束 , taskId 存在说明这不是一条单纯的通知,需要操作
              if(this.procData.sid && this.procData.taskId){
        
                //如果查到了最新的sid,就还需要去查询该节点的节点配置信息
                let systemid = this.systemId.getSystemId()
                let param2 = {
                  entity:{keyWord:this.procData.keyWord,systemId:systemid,version:this.procData.version},
                  param:{pageSize:0}
                }
                //查询所有节点的配置信息
                this.http.Post(environment.activitiWebAPI+'swActivitiTask/queryNoteToConfig?keyWord='+param2.entity.keyWord+'&version='+param2.entity.version,{}).subscribe(ret=>{
                  if(ret && ret.code == 200){
                    let nodeInfos = ret.data
                    //根据最新的sid找到该节点
                    let nodeInfo = nodeInfos.filter(item=>item.userTaskId == this.procData.sid)
                    if(nodeInfo.length){
                      //找到该节点的常量和变量配置信息
                      let buttonList = nodeInfo[0]['buttonList']  
                      if(buttonList){
                        //找到 buttonList 里面的变量配置,抛出
                        if(this.isHide){
                          let type2List = buttonList.filter(item => item.type == 2)
                          if(type2List.length){
                            this.votedNodeConfig.emit(type2List)
                          }
                        }
                        //找到该节点的变量配置信息中name值为BusinessIdFileUpload的，是说明是业务附件上传
                        this.businessFileCodes = buttonList.filter(v => v.type ==2 && v.name == 'BusinessIdFileUpload')
                        
                        //找到该节点的变量配置信息中name值为BusinessInput的，是说明是业务输入框
                        this.businessInputs = buttonList.filter(v => v.type ==2 && v.name == 'BusinessInput')
                        
                        let approvalInfo 
                        buttonList.forEach(v => {
                          //找到该节点的常量配置信息中是否有 "approval" , 如果有,就说明该节点可以挂载子流程
                          if(v.value &&  v.value == "approval" && v.type == 3){
                            approvalInfo = v
                          }
                          //审批意见在和常量中都可以配置，如果两个都配置了，优先常量
                          //先找到该节点的常量配置信息中是否有 "placeholder" , 如果有,就说明该节点指定了审批意见
                          if(v.value &&  v.value.indexOf("placeholder:") != -1 && v.type == 3){
                            let i = v.value.indexOf(':')
                            //截取冒号后面的字符回填,如果冒号后面有审批意见就回填
                            this.message = v.value.substr(i+1)
                          }
                          //先找到该节点的常量配置信息中是否有 "receiverIds" , 如果有,就说明该节点配置了抄送人按钮
                          if(v.value &&  v.value.indexOf("receiverIds:") != -1 && v.type == 3){
                            this.receiver = v.value.split(':')[1]
                          }
                        });
                        //如果常量配置处理完之后， 审批意见还是空的，就去查询变量中有没有配置
                        if(!this.message){
                          let commentArr = buttonList.filter(v => v.type ==2 && v.name == 'BusinessComment')
                          if(commentArr.length > 0){
                            this.http.Post(environment.activitiWebAPI+'activitiRunTime/getProcessVariableValueByKey?key=BusinessComment&taskId='+this.procData.taskId,{}).subscribe(res=>{
                              if(res.code == 200){
                                this.message = res.data
                              }
                            })
                          }
                        } 
                        //如果配置了子流程常量信息
                        if(approvalInfo){
                          this.canSetAppr = true
                        }
                      }
                    } else {
                      this.box.danger("找不到该节点的配置信息")
                    }
                    //获取当前登入用户
                    this.userModel = this.User.getUser();
                    //初始化历史数据
                    this.location();
                    //创建唯一id
                    this.ids = "modal" + Math.random().toString().split(".")[1];
                  }
                })
              } else {
                //获取当前登入用户
                this.userModel = this.User.getUser();
                //初始化历史数据
                this.location();
                //创建唯一id
                this.ids = "modal" + Math.random().toString().split(".")[1];
              }
            } else {
              //这个流程从来都不存在,或者说这根本就不是一个流程,或者是由指令创建的
              //获取当前登入用户
              this.userModel = this.User.getUser();
              //初始化历史数据
              this.location();
              //创建唯一id
              this.ids = "modal" + Math.random().toString().split(".")[1];
            }
          } else {
            // this.procDataErrorTip = '流程数据异常，请重试！'
            this.disabled = false  //正在加载按钮隐藏
          }
        } 
      })
    }
    
  }
  
  
  /**
   * 初始化获取历史记录
   * @ignore
   */
  location() {
    this.workFlowModel = [];
    let uri = ""
    if (this.isHide) {
      //正常状态下获取数据
      uri = environment.activitiWebAPI + "swActivitiTaskRecord/getRecordByPid?pid=" + this.procData.procInstId;
      //审核附件上传的业务id
      this.businessId = this.procData.taskId  
      //业务附件上传的业务id
      this.anotherBusinessId = this.procData.businessId 
    } else {
      if(this.fromId.indexOf('procInstId') != -1){
        // 如果是根据 procInstId 去查，先找到 procInstId
        let pidArr = this.fromId.split(':')
        let procInstId = pidArr[1]
        uri = environment.activitiWebAPI + "swActivitiTaskRecord/getRecordByPid?pid=" + procInstId;
      } else {
        // 否则就根据 businessKey 去查
        uri = environment.activitiWebAPI + "swActivitiTaskRecord/getHistoryTaskListByBusinessKey?businessKey=" + this.fromId;

      }
      //指令创建的状态下获取数据
      // uri = environment.activitiWebAPI + "swActivitiTaskRecord/getHistoryTaskListByBusinessKey?businessKey=" + this.fromId;
    }
    //查到所有的审核数据
    this.http.Post(uri, {}).subscribe(data => {
      if (data["data"]) {
        data["data"].forEach(e => {
          //如果审核记录中有抄送人信息的话，处理一下，直接放在记录下来的noticerIds ， 格式是 id 组成的字符串，逗号隔开
          if(e.localVariables){
            let v = JSON.parse(e.localVariables)
            if(v.noticerIds){
              e.noticerIds = v.noticerIds.join(',')
            }
          }
          this.workFlowModel.push(e) 
        });
      }
      // console.log('isHide-->'+this.isHide +'  hasTaskId--'+this.hasTaskId +'  flowType--'+this.procData.flowType+'  sid--'+this.procData.sid+'  firstSid--'+this.procData.firstSid+'  isLast--'+this.procData.isLast);

      if(this.workFlowModel.length){
        this.processTitle = this.workFlowModel[0].title  //显示在审核组件头部的标题
        this.procStatus = this.workFlowModel[0].procStatus  //审核状态判断的标准
        this.procDefId = this.workFlowModel[0].procDefId  //pdid , 每一个节点都是一样的

        // 历史记录查询成功（最少也有一条发起人的历史记录）
        this.disabled = false  //按钮可以点击了
        
        // 1. 按钮组只能在 isHide = true 的时候才会出现
        // 2. 判断能否展示重新提交按钮 (跳转到业务编辑页面,且有保存并提交按钮)
        // 2.1 流程已被拒绝或已被撤销且 flowType = 2,且 isLast 为true 的情况下可以跳转 (isLast为了区分一个流程不能多次重新提交)
        // 2.2 流程已同意下结束, 且关键字中含有 '_UPDATE' 或者是 "_EDIT" 的情况下,且 isLast 为true时可以跳转
        this.canSubmit = (this.procData.flowType == 2 && this.procStatus=='拒绝' && this.procData.isLast) || (this.procData.flowType == 2 && this.procStatus=='已撤销' && this.procData.isLast) || (this.procStatus=='审核通过' && this.procData.keyWord.indexOf("_UPDATE") != -1 && this.procData.isLast) || (this.procStatus=='审核通过' && this.procData.keyWord.indexOf("_EDIT") != -1 && this.procData.isLast)

        // 3. 判断能否展示撤销按钮,如果流程还没结束且发起人是当前用户的话就可以显示
        this.canRevocate = (this.workFlowModel.length == 1) && (this.workFlowModel[0].submitter == this.userModel.userId)   

        // 4. 其他的同意 , 退回 , 拒绝 三个按钮都是在 isHide 为 true ,且 hasTaskId 也为 true 的时候会出现
        if(this.isHide && this.fromId && this.fromId.procInstId){
          // 5. 其他三个按钮的判断需要根据 两个基础条件来判断,要有 sid 和 firstSid ,   2.当前用户是否是发起人
          if(this.procData && this.procData.firstSid && this.procData.sid){  //有 firstSid 和 sid 的情况下
            // 6. sid 和 firstSid 存在时, 
            // 6.1 当前节点是否是发起节点
            let isStartNode = this.procData.sid == this.procData.firstSid
            // 6.2 当前用户是否是发起人
            let isSubmitter = this.workFlowModel[0].submitter == this.userModel.userId
            // 7. 判断是否出现退回按钮,只要当前节点不是发起节点,就可以出现
            // this.canUnTask = !isStartNode 
            // 8.判断是否出现编辑业务按钮 (跳转到业务编辑页面,且有保存业务按钮)
            this.canToEdit = isStartNode &&  isSubmitter && this.procData.flowType == 2 
          }else{
            //sid 和 firstSid 不存在的情况下,
            // this.canUnTask = false  //不能驳回
            this.canToEdit = false  //不能编辑
          }
        } else if(this.fromId){
          //指令创建的工作量,formId就是 businessKey , 就只需要判断撤销按钮是否出现
          // this.canUnTask = false  //不能驳回
          this.canToEdit = false  //不能编辑
        }
        // console.log("跳转到保存提交按钮- canSubmit : "+this.canSubmit + "  撤销按钮- canRevocate : "+this.canRevocate + "  退回按钮- canUnTask : "+this.canUnTask + "  拒绝和同意按钮- hasTaskId && isHide")
        
      }
    })

  }
  
  /**
   * 查看流程图,修改 状态为false, 此时再点击无效
   * @ignore
   */
  clickImg() {
    if(this.canClickAgain){
      this.canClickAgain = false  //让流程图再次点击时无效,避免短时间点击多次
      let systemid = this.systemId.getSystemId()
      let uri = ""
      if (this.isHide) {
        //正常情况下进入工作流组件
        uri = `${environment.activitiWebAPI}activitiModel/getProcessPngByPid?pid=${this.procData.procInstId}&systemId=${systemid}`
      } else {
        //通过指令进入工作流组件
        if(this.fromId.indexOf('procInstId') != -1){
          // 如果是根据 procInstId 去查，先找到 procInstId
          let pidArr = this.fromId.split(':')
          let procInstId = pidArr[1]
          uri = `${environment.activitiWebAPI}activitiModel/getProcessPngByPid?pid=${procInstId}&systemId=${systemid}`
        } else {
          // 否则就根据 businessKey 去查
          uri = `${environment.activitiWebAPI}activitiModel/getProcessPngByBusinessKey?businessKey=${this.fromId}&systemId=${systemid}&type=`
        }
        // uri = `${environment.activitiWebAPI}activitiModel/getProcessPngByBusinessKey?businessKey=${this.fromId}&systemId=${systemid}&type=`
      }
      let param = {
        url:uri ,
        showModal:'yes'
      }
      this.create.createModal(SwFlowChartComponent,param,this.changeStatus.bind(this))
    }
  }

  /**
   * 当关闭流程图组件的时候,修改状态,才能再次查看流程图
   * @ignore
   */
  changeStatus(){
    //当关闭流程图模态框之后,才允许再次点击查看流程图,以及其他操作按钮
    this.canClickAgain = true
  }

  /**
   * 点击同意或退回按钮, 0表示退回 , 1表示点击同意 , 2表示拒绝 , 3表示撤回 , 除了同意之外,其他按钮都要弹出确认框
   * @ignore
   */
  clickAction(action){  
    this.action = action
    if(this.action == "3"){
      //撤销
      this.swMessageConfirmService.showConfirmModal("该操作将导致流程终止，是否继续？",'请选择',this.revocate.bind(this));
    } else if(this.action == "2"){
      //拒绝,意见是必填项
      if (!this.message) { 
        this.box.danger("请填写拒绝意见")
        return
      }  else {
        this.swMessageConfirmService.showConfirmModal("该操作将导致流程终止，是否继续？",'请选择',this.clickReAudit.bind(this));
      }
    } else if(this.action == "0"){
      //退回,意见是必填项
      if (!this.message) { 
        this.box.danger("请填写退回意见")
        return
      }  else {
        // this.swMessageConfirmService.showConfirmModal("该操作将导致流程退回至上一步审批流程，是否继续？",'请选择',this.checkNextHandle.bind(this));  //先查询要退回到上一步的人,该功能暂时没有实现,此行注释不要删
        //直接进行退回操作
        this.clickUnTask()
      }
    } else if(this.action == "1"){
      //同意
      this.checkNextHandle()
    } else if(this.action == "4"){
      //撤回
      this.revoke()
    }
  }

  /**
   * 如果是同意或退回操作,要先看是否需要配置指定执行人
   * @ignore
   */
  checkNextHandle(){
    let type = Number(this.action)
    //先看是否需要配置指定执行人
    this.http.Post(`${environment.activitiWebAPI}activitiModel/checkNextHandle?taskId=${this.procData.taskId}&pdId=${this.procDefId}&sid=${this.procData.sid}&type=${type}&version=${this.procData.version}&keyWord=${this.procData.keyWord}`,this.variables)
    .subscribe(res=>{
      if(res && res.code == 200){
        if(!res["data"]){
          //如果返回结果为空,就不配置指定执行人,直接进行审核操作
          if(this.action == '1'){
            //审核通过
            this.clickTask()
          } 
          // else if(this.action == '0'){
          //   //审核退回
          //   this.clickUnTask()
          // }

        } else {
          //如果是本单元用户加单选就返回 ["single_unitUser"] ， 如果是设置审批人加单选就返回  ["single_user", "3e707e74739b4ddf708974c3dca216a8", "5da5ca3036a5cbab2467fea0265b5505",…]
          //如果是本单元用户加多选就返回 ["unitUser"] ， 如果是设置审批人加多选就返回  ["3e707e74739b4ddf708974c3dca216a8", "5da5ca3036a5cbab2467fea0265b5505",…]
          //如果是 无需配置就返回 ["allUser"]
          this.operatorIds = res["data"]
          if(this.action == '1'){
            if(this.operatorIds.length){
              if(this.operatorIds[0] == 'allUser'){
                //如果是配置所有人
                this.create.createModal(SwAddressBookComponent,{userId:[],headerLogo:"审批人区域"},this.clickTask.bind(this))
              } else if(this.operatorIds[0].indexOf('unitUser') != -1 ){
                //如果是设置本单位用户
                let multi = this.operatorIds[0].indexOf('single') == -1 ? 'multi' : 'single' //看是单选还是多选
                this.create.createModal(SwOperatorModalComponent,{headerLogo:"选择审批/办理人",operatorIds:'unitUser',operatorMulti:multi},this.clickTask.bind(this))
              } else if (this.operatorIds[0] == 'inclusiveGateWayUser') {
                this.inclusiveGateWayUser = true
                //如果用户的id存在,就取获取所有用户的信息,找到对应的用户, 得到找到执行人的下拉列表的数组
                this.create.createModal(SwOperatorModalComponent,{headerLogo:"选择审批/办理人",operatorIds:this.operatorIds},this.clickTask.bind(this))
              } else {
                let multi = 'multi'  //默认多选
                if(this.operatorIds[0].indexOf('single_user') != -1){
                  //如果设置的单选
                  multi = 'single'
                  this.operatorIds.shift()  //删掉数组的第一个元素，剩下的就是id
                }
                //如果用户的id存在,就取获取所有用户的信息,找到对应的用户, 得到找到执行人的下拉列表的数组
                this.create.createModal(SwOperatorModalComponent,{headerLogo:"选择审批/办理人",operatorIds:this.operatorIds,operatorMulti:multi},this.clickTask.bind(this))
              }
            } else {
              this.box.danger("没有能选择的执行人")
            }
          } 
          // else if(this.action == '0'){
          //   //审核退回
          //   this.variables.assigneeList = this.operatorIds
          //   this.clickUnTask()
          // }
        }
      } 
    })
  }

  /**
   * 审核退回
   * @ignore
   */
  clickUnTask() {
    //立刻打开遮罩层
    this.swMaskService.openMask('正在退回,请稍等...')
    let param = {
      taskId: this.procData.taskId,
      comment: this.message,
      variables:this.variables,
    }
    this.http.Post(environment.activitiWebAPI + "activitiRunTime/unPassTaskByTaskId", param).subscribe(data => {
      if (data["code"] == 200) {
        //将保存附件的过程放在退回成功后执行，因为点击退回时，后台可能返回‘无法退回到发起节点’，此时附件不能保存，要确定成功退回再保存附件
        //将上传过程的文件信息存进附件表
        if (this.workFlowFiles) {
          if (this.workFlowFiles.addList.length != 0) {
            this.fileService.save(this.businessId, this.fileCode, this.workFlowFiles.addList).subscribe(
              res => {
              }
            );
          }
        }

        //将业务附件上传过程的文件信息存进附件表
        if (this.businessFileCodes && this.businessFiles) {
          //业务附件上传后都会存进 this.businessFiles 这个对象中， key就是 文件策略， value就是上传的文件信息
          for (const key in this.businessFiles) {
            if(this.businessFiles[key]['addList']){
              //如果该策略上传了文件， 就先将文件存入 对应的策略和 this.procData.businessId 中去
              this.fileService.save(this.procData.businessId, key, this.businessFiles[key]['addList']).subscribe(
                res => {
                  if(res.code == 200){
                    //由于每个节点的 this.procData.businessId 都是一样的 ， 所以还需要细分保存在 taskId 中
                    //保存成功之后， 再将文件存入对应的策略和 this.businessId 中去， this.businessId = this.procData.taskId
                    this.fileService.save(this.businessId, key, this.businessFiles[key]['addList']).subscribe(
                      res => {
                      }
                    );
                  }
                }
              );
            }
          }
        }

        //将配置的常量保存
        if(this.approvalPageList.length){
          this.saveApproval()
        }

        //complete:是否完成流程0:未完成,1完成 ;
        // code: 1 通过 2 退回 3 拒绝 4 撤销 
        // status: 1--审核中（此时 complete=0，code=1 或 code=2） , 2--通过（此时 complete=1. code =1） , 3 --> 审核中（此时 complete=0， code =2） , 4--拒绝（此时 complete=1. code =3）, 5--撤销 （complete=1. code =4）, 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
        //此时是退回操作，流程一定没结束，complete=0, code=2, status=3
        let status = 3
        let res = {
          complete: data.data.completeFlag,
          code: 2,
          status:status
        }
        //如果是删除或修改流程（都是不可编辑流程），点击退回按钮，那么status = 999
        if(this.procData.flowType == 1){  //如果是不可编辑流程,那么抛出的code就为 -99 , 意味着业务数据状态不需要改变
          res.code = 999
          res.status = 999  
        }
        // 抛出审核状态
        this.voted.emit(res);

        // 如果变量中配置了业务输入框在审核组件中，那么退回之后也要将此输入结果抛出给业务
        if(this.businessInputs.length){
          this.votedNodeConfigResult.emit(this.businessInputValue)
        }

        //关闭遮罩层
        this.swMaskService.closeMask()
        //关闭当前审核页面
        if(this.openType ==1){
          this.todos.oninitProcessToDos()
          this.tagServe.closeUrl();
        }
        this.todos.sendAuditMessage('审核退回') //刷新审核操作,为了通知待办页面刷新数据
        this.box.success("审核退回");
      }else {
        //关闭遮罩层
        this.swMaskService.closeMask()
        this.box.danger(data.msg)
      }
    })
  }


  /**
   * 审核拒绝
   * @ignore
   */
  clickReAudit() {
    //立刻打开遮罩层
    this.swMaskService.openMask('正在拒绝,请稍等...')
    let param = {
      variables:this.variables,
    }
    this.http.Post(environment.activitiWebAPI + "activitiRunTime/reAuditByBusinessKey?businessKey=" + this.procData.businessKey + "&comment=" + this.message, param).subscribe(data => {
      if (data["code"] == 200) {
        //保存审核附件
        if (this.workFlowFiles) {
          if (this.workFlowFiles.addList.length != 0) {
            this.fileService.save(this.businessId, this.fileCode, this.workFlowFiles.addList).subscribe(
              res => {
              }
            );
          }
        }
    
        //将业务附件上传过程的文件信息存进附件表
        if (this.businessFileCodes && this.businessFiles) {
          //业务附件上传后都会存进 this.businessFiles 这个对象中， key就是 文件策略， value就是上传的文件信息
          for (const key in this.businessFiles) {
            if(this.businessFiles[key]['addList']){
              //如果该策略上传了文件， 就先将文件存入 对应的策略和 this.procData.businessId 中去
              this.fileService.save(this.procData.businessId, key, this.businessFiles[key]['addList']).subscribe(
                res => {
                  if(res.code == 200){
                    //由于每个节点的 this.procData.businessId 都是一样的 ， 所以还需要细分保存在 taskId 中
                    //保存成功之后， 再将文件存入对应的策略和 this.businessId 中去， this.businessId = this.procData.taskId
                    this.fileService.save(this.businessId, key, this.businessFiles[key]['addList']).subscribe(
                      res => {
                      }
                    );
                  }
                }
              );
            }
          }
        }
        //将配置的常量保存
        if(this.approvalPageList.length){
          this.saveApproval()
        }
        //complete:是否完成流程0:未完成,1完成 ;
        // code: 1 通过 2 退回 3 拒绝 4 撤销 
        // status: 1--审核中（此时 complete=0，code=1 或 code=2） , 2--通过（此时 complete=1. code =1） , 3 --> 审核中（此时 complete=0， code =2） , 4--拒绝（此时 complete=1. code =3）, 5--撤销 （complete=1. code =4）, 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
        //此时是拒绝操作，流程一定结束，complete=1, code=3, status一定是4
        let status = 4
        let res = {
          complete: data.data.completeFlag,
          code: 3,
          status:status
        }
        //如果是删除或修改流程（都是不可编辑流程），点击拒绝按钮，那么 status = 999
        if(this.procData.flowType == 1){  //如果是不可编辑流程,那么抛出的code就为 -99 , 意味着业务数据状态不需要改变
          res.code = 999
          res.status = 999  
        }
        // 抛出状态
        this.voted.emit(res);
        
        // 如果变量中配置了业务输入框在审核组件中，那么退回之后也要将此输入结果抛出给业务
        if(this.businessInputs.length){
          this.votedNodeConfigResult.emit(this.businessInputValue)
        }

        //关闭遮罩层
        this.swMaskService.closeMask()
        this.todos.sendAuditMessage('拒绝成功') //刷新审核操作,为了通知待办页面刷新数据
        this.box.success("拒绝成功");
        //关闭当前审核页面
        if(this.openType ==1){
          this.todos.oninitProcessToDos()
          this.tagServe.closeUrl();
        }
      }else {
        //关闭遮罩层
        this.swMaskService.closeMask()
        this.box.danger(data.msg)
      }
    })
  }


  /**
   * @ignore
   * 审核通过
   */
  clickTask(operatorIds?) {
    if(this.inclusiveGateWayUser){
      this.variables.inclusiveGateWayUser = operatorIds || null
    } else{
      //是否有审批人,如果有就加到 variables 里面
      this.variables.assigneeList = operatorIds || null
    }
    //立刻打开遮罩层
    this.swMaskService.openMask('正在同意,请稍等...')
    if (this.message == undefined || this.message == null) {
      this.message = "";
    }
    let param = {
      taskId: this.procData.taskId,
      comment: this.message,
      variables:this.variables,
    }
    this.http.Post(environment.activitiWebAPI + "activitiRunTime/passTaskByTaskId", param).subscribe(data => {
      if (data["code"] == 200) {
        //将上传过程的文件信息存进附件表
        if (this.workFlowFiles) {
          if (this.workFlowFiles.addList.length != 0) {
            this.fileService.save(this.businessId, this.fileCode, this.workFlowFiles.addList).subscribe(
              res => {
              }
            );
          }
        }
    
        //将业务附件上传过程的文件信息存进附件表
        if (this.businessFileCodes && this.businessFiles) {
          //业务附件上传后都会存进 this.businessFiles 这个对象中， key就是 文件策略， value就是上传的文件信息
          for (const key in this.businessFiles) {
            if(this.businessFiles[key]['addList']){
              //如果该策略上传了文件， 就先将文件存入 对应的策略和 this.procData.businessId 中去
              this.fileService.save(this.procData.businessId, key, this.businessFiles[key]['addList']).subscribe(
                res => {
                  if(res.code == 200){
                    //由于每个节点的 this.procData.businessId 都是一样的 ， 所以还需要细分保存在 taskId 中
                    //保存成功之后， 再将文件存入对应的策略和 this.businessId 中去， this.businessId = this.procData.taskId
                    this.fileService.save(this.businessId, key, this.businessFiles[key]['addList']).subscribe(
                      res => {
                      }
                    );
                  }
                }
              );
            }
          }
        }
        //将配置的常量保存
        if(this.approvalPageList.length){
          this.saveApproval()
        }

        if(data.data.completeFlag == 1 && this.variables.stopClose){  //审核通过时新增判断是否关闭当前页面
          //关闭当前审核页面
          if(this.openType ==1){
            this.todos.oninitProcessToDos()
          }
        } else {
          //关闭当前审核页面
          if(this.openType ==1){
            this.todos.oninitProcessToDos()
            this.tagServe.closeUrl();
          }
        }
        //关闭遮罩层
        this.swMaskService.closeMask()
        //complete:是否完成流程0:未完成,1完成 ;
        // code: 1 通过 2 退回 3 拒绝 4 撤销 
        // status: 1--审核中（此时 complete=0，code=1 或 code=2） , 2--通过（此时 complete=1. code =1） , 3 --> 审核中（此时 complete=0， code =2） , 4--拒绝（此时 complete=1. code =3）, 5--撤销 （complete=1. code =4） , 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
        //此时是通过操作， code=1, status要根据complete决定，如果 complete=0（流程未结束），那么status=1 , 如果 complete=1（流程已结束），那么status=2
        let status = data.data.completeFlag == '1' ? 2 : 1;
        let res = {
          complete: data.data.completeFlag,
          code: 1,
          status:status
        }
        //如果是删除或修改流程（都是不可编辑流程）
        if(this.procData.flowType == 1){ 
          if(this.procData.keyWord.indexOf('_EDIT') != -1 || this.procData.keyWord.indexOf('_UPDATE') != -1){
            //如果是修改流程,点击通过，那么 status = 991
            res.code = 991
            res.status = 991  
          } else if(this.procData.keyWord.indexOf('_DELETE') != -1){
            //如果是删除流程,在流程结束且通过之后，status = 992
            if(res.complete == 1 && res.code == 1){
              res.code = 992
              res.status = 992
            } else {
              //如果是删除流程,在流程未结束，且点击通过按钮时，自定义表单需要更新业务数据
              res.code = 991
              res.status = 991 
            }
          }
        }
        // 抛出状态
        this.voted.emit(res);
        
        // 如果变量中配置了业务输入框在审核组件中，那么退回之后也要将此输入结果抛出给业务
        if(this.businessInputs.length){
          this.votedNodeConfigResult.emit(this.businessInputValue)
        }

        this.todos.sendAuditMessage('审核通过') //刷新审核操作,为了通知待办页面刷新数据
        this.box.success("审核通过")
      }else {
        //关闭遮罩层
        this.swMaskService.closeMask()
        this.box.danger(data.msg)
      }
    })
  }

  /**
   * 审核组件附件上传,该上传策略就是固定的审核组件的
   * @ignore
   * @param event 
   */
  getWorkFlowFileInfo(event) {
    //上传附件成功
    this.workFlowFiles = event
  }

  /**
   * 业务附件上传,该上传策略是节点配置的时候用户自己填的
   * @ignore
   * @param event 
   */
  getBusinessFileInfo(event,fileCode) {
    //上传附件成功
    this.businessFiles[fileCode] = event;
  } 
  
  /**
   * 点击按钮切换工作流的显示与隐藏
   * @ignore
   */
  switchWorkFlow(event,action,recOrWork){
    //如果不能显示工作流,且点击的就是审批,就不进行操作
    if(action == 'show'){
      //点击审核或推荐按钮让组件出现
      this.right = '0'
      this.recOrWork = recOrWork
    } else if(recOrWork == null){
      // 点击的是组件左侧的收缩按钮,recOrWork 此时为 null
      this.right = '-140%'
    } else if(this.recOrWork == recOrWork){
      //如果点击的按钮是已经显示的,就直接收缩
      this.right = '-140%'
      this.recOrWork = recOrWork
    } else if(this.recOrWork != recOrWork){
      //如果点击的按钮时没有显示的,就切换显示区域
      this.recOrWork = recOrWork
    }
  }
  
  /**
   * 点击组件的右上角关闭按钮,如果是指令创建的,就直接销毁,否则就只是隐藏
   * @ignore
   */
  clickToClose(event){
    if(this.isHide){
      this.right = '-140%'
    } else {
      this.voted.emit()
    }
  }

  /**
   * 将处理人取最后两位展示
   * @ignore
   */
  getFinalName(name:string){
    if(name){
      let newName = name.substring(name.length-2,name.length)
      return newName
    }
  }

  /**
   * 点击重新提交按钮
   * @ignore
   */
  clickToEdit(type){
    let showSubmitBtn,showSaveBtn
    let businessKey = this.procData.keyWord + ":" + this.procData.businessId
    if(type == 'submit'){
     showSubmitBtn = true  //出现保存并提交按钮
     showSaveBtn = false  //不出现保存按钮
     //如果 keyWord 里面有 '_UPDATE' 或 '_EDIT',就说明也要跳转,但是跳转之前 keyWord 中的'_UPDATE' / '_EDIT'要去掉
     let i = -1  //默认两种关键字都没有
     if(this.procData.keyWord.indexOf('_UPDATE') != -1){
      i = this.procData.keyWord.indexOf('_UPDATE')
     } else if(this.procData.keyWord.indexOf('_EDIT') != -1){
      i = this.procData.keyWord.indexOf('_EDIT')
     }
     if(i != -1){  //存在此字符串,就要去掉
       let keyWord = this.procData.keyWord.substring(0,i)
       businessKey = keyWord + ":" + this.procData.businessId
     }
    } else if(type == 'save'){
     showSubmitBtn = false //不出现保存并提交按钮
     showSaveBtn = true //出现保存按钮
    }
   let param = {
     businessKey: businessKey,
     taskId: this.procData.taskId,
     sid: this.procData.sid,
     version:this.procData.version,
     showSaveBtn:showSaveBtn,  //业务中出现保存按钮
     showSubmitBtn:showSubmitBtn  //展示重新提交按钮
   };
   if(this.procData.submitUrl){
     //接下来判断是用tab页打开还是模态框打开
     if(this.procData.openType == 1){
      //点击重新提交会跳转到业务编辑页面，为了防止在业务编辑页面里面保存并提交成功后，该页面的重新提交按钮还是存在，页面也不好刷新，所以现在直接把这个页面关掉
      this.tagServe.closeUrl()  //该方法不传入参数，默认关闭当前页面
       //如果打开方式是 tab页 的话
       this.router.navigateByUrl('').then(()=>{
         this.router.navigate([this.procData.submitUrl], { queryParams: { Title: this.procData.flowName, Operate: BdpEnum.SYS_PROCESS_UPDATE, Type:1, data: JSON.stringify(param) } });
       })
     } else if(this.procData.openType == 2){ 
       //如果是用模态框打开
       let fact = this.cfr["_factories"]
       //对参数进行处理
       let modalParam = this.procData.params ? JSON.parse(this.procData.params) : {}
       let queryParams = { Title: this.procData.flowName, Operate:BdpEnum.SYS_PROCESS_VERIFY,Type:1, data: JSON.stringify(param) }
       let params = {param: modalParam,queryParams: queryParams}
       fact.forEach((value:any,key:any)=>{
         if(value.selector == this.procData.submitUrl){
           this.create.createModal(key,params)
         }
       })
     }
   } else {
     this.box.danger("没有跳转链接")
   }
 }

  //----------------------------------------子流程配置-开始----------------------------------

  /**
   * 点击按钮,创建常量配置模态框
   * @ignore
   */
  openApprovalSet(){
    //创建选择子流程模态框组件,并将页面上已经存在的
    this.create.createModal(SwApprovalModalComponent,{approvalPageList:this.approvalPageList},this.sureApproval.bind(this))
  }

  /**
   * 从页面中删除常量配置
   * @ignore
   */
  deleteApprFromPage(item,i){
    this.approvalPageList.splice(i,1)
  }

  /**
   * 点击模态框常量配置的确定按钮,模态框传递出来选中的子流程,在页面上展示出来
   * @ignore
   */
  sureApproval(data){
    this.approvalPageList = JSON.parse(JSON.stringify(data))
  }

  /**
   * 发送请求,保存配置好的子流程
   * @ignore
   */
  saveApproval(){
    let addIds = this.approvalPageList.map(item=>item.procInstId)
    let param = {
      str:this.procData.taskId,
      addIds:addIds
    }
    this.http.Post(environment.activitiWebAPI+`activitiProcess/saveBatch`,param).subscribe(res=>{
      if(res && res.code == 200){
      } else {
        this.box.danger("常量配置失败")
      }
    })
  }

  //----------------------------------------子流程配置-结束----------------------------------
  
  /**
   * 点击跳转到子流程
   * @ignore
   */
  clickToSonProcess(data){
    if(data.keyWord && data.businessId && data.url){
      let param = {
        businessKey: data.keyWord + ":" + data.businessId,
        procInstId:data.procInstId
      };
      //接下来判断是用tab页打开还是模态框打开
      if(data.openType == 1){  //跳转方式 openType 和 跳转地址 url  应该由子流程提供
        //如果打开方式是 tab页 的话
      this.router.navigateByUrl('').then(()=>{
        this.router.navigate([data.url], { queryParams: { Title: data.flowName, Operate: BdpEnum.SYS_PROCESS_VIEW, Type:1, data: JSON.stringify(param) } });
      })
      } else if(data.openType == 2){ //跳转方式 openType 和 跳转地址 url 跳转参数 params 应该由子流程提供
        //如果是用模态框打开
        let fact = this.cfr["_factories"]
        //对参数进行处理
        let modalParam = data.params ? JSON.parse(data.params) : {}  //流程设计中配置的参数
        let queryParams = { Title: data.flowName, Operate:BdpEnum.SYS_PROCESS_VIEW,Type:1, data: JSON.stringify(param) }  //自己写入的参数
        let params = {param: modalParam,queryParams: queryParams}
        fact.forEach((value:any,key:any)=>{
          if(value.selector == data.url){
            this.create.createModal(key,params)
          }
        })
      }
    }
  }

  /**
   * 点击撤销按钮
   * @ignore
   */
  revocate(){
    //立刻打开遮罩层
    this.swMaskService.openMask('正在撤销,请稍等...')
    let param = {
      variables:this.variables,
    }
    this.http.Post(`${environment.activitiWebAPI}activitiRunTime/taskReturn?pid=${this.procData.procInstId}`,param).subscribe(data=>{
      if(data && data.code == 200){
        if (this.workFlowFiles) {
          if (this.workFlowFiles.addList.length != 0) {
            this.fileService.save(this.businessId, this.fileCode, this.workFlowFiles.addList).subscribe(
              res => {
              }
            );
          }
        }
    
        //将业务附件上传过程的文件信息存进附件表
        if (this.businessFileCodes && this.businessFiles) {
          //业务附件上传后都会存进 this.businessFiles 这个对象中， key就是 文件策略， value就是上传的文件信息
          for (const key in this.businessFiles) {
            if(this.businessFiles[key]['addList']){
              //如果该策略上传了文件， 就先将文件存入 对应的策略和 this.procData.businessId 中去
              this.fileService.save(this.procData.businessId, key, this.businessFiles[key]['addList']).subscribe(
                res => {
                  if(res.code == 200){
                    //由于每个节点的 this.procData.businessId 都是一样的 ， 所以还需要细分保存在 taskId 中
                    //保存成功之后， 再将文件存入对应的策略和 this.businessId 中去， this.businessId = this.procData.taskId
                    this.fileService.save(this.businessId, key, this.businessFiles[key]['addList']).subscribe(
                      res => {
                      }
                    );
                  }
                }
              );
            }
          }
        }
        //将配置的常量保存
        if(this.approvalPageList.length){
          this.saveApproval()
        }
        this.box.success("撤销成功")
        //关闭遮罩层
        this.swMaskService.closeMask()
        //complete:是否完成流程0:未完成,1完成 ;
        // code: 1 通过 2 退回 3 拒绝 4 撤销 
        // status: 1--审核中（此时 complete=0，code=1 或 code=2） , 2--通过（此时 complete=1. code =1）  , 3 --> 审核中（此时 complete=0， code =2）, 4--拒绝（此时 complete=1. code =3）, 5--撤销 （complete=1. code =4） , 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
        //此时是撤销操作，流程已结束，complete=1, code=4, status=5
        let status = 5
        let res = {
          complete: "1",
          code: 4,
          status : status
        }
        //如果是删除或修改流程（都是不可编辑流程），点击撤销按钮 ，那么 status = 999
        if(this.procData.flowType == 1){ 
          res.code = 999
          res.status = 999 
        }
        // 抛出状态
        this.voted.emit(res);
        
        // 如果变量中配置了业务输入框在审核组件中，那么退回之后也要将此输入结果抛出给业务
        if(this.businessInputs.length){
          this.votedNodeConfigResult.emit(this.businessInputValue)
        }

        this.todos.sendAuditMessage('撤销成功') //刷新审核操作,为了通知待办页面刷新数据
        this.todos.oninitProcessToDos()  //刷新工作台待办
        //关闭当前审核页面
        if(this.openType ==1){
          this.tagServe.closeUrl();  //关闭当前标签页
        }
      } else {
        //关闭遮罩层
        this.swMaskService.closeMask()
        this.box.danger(data.msg)
      }
      })
  }

  /**
   * 点击撤回按钮
   * @ignore
   */
  revoke(){
    //立刻打开遮罩层
    this.swMaskService.openMask('正在撤回,请稍等...')
    let param = {
      procInstId:this.fromId.procInstId,
      comment: this.message,
      variables:this.variables,
    }
    this.http.Post(`${environment.activitiWebAPI}activitiRunTime/taskRevoke`,param).subscribe(data=>{
      if(data && data.code == 200){
        //保存审核附件
        if (this.workFlowFiles) {
          if (this.workFlowFiles.addList.length != 0) {
            this.fileService.save(this.businessId, this.fileCode, this.workFlowFiles.addList).subscribe(
              res => {
              }
            );
          }
        }

        //将业务附件上传过程的文件信息存进附件表
        if (this.businessFileCodes && this.businessFiles) {
          //业务附件上传后都会存进 this.businessFiles 这个对象中， key就是 文件策略， value就是上传的文件信息
          for (const key in this.businessFiles) {
            if(this.businessFiles[key]['addList']){
              //如果该策略上传了文件， 就先将文件存入 对应的策略和 this.procData.businessId 中去
              this.fileService.save(this.procData.businessId, key, this.businessFiles[key]['addList']).subscribe(
                res => {
                  if(res.code == 200){
                    //由于每个节点的 this.procData.businessId 都是一样的 ， 所以还需要细分保存在 taskId 中
                    //保存成功之后， 再将文件存入对应的策略和 this.businessId 中去， this.businessId = this.procData.taskId
                    this.fileService.save(this.businessId, key, this.businessFiles[key]['addList']).subscribe(
                      res => {
                      }
                    );
                  }
                }
              );
            }
          }
        }
        //将配置的常量保存
        if(this.approvalPageList.length){
          this.saveApproval()
        }
        this.box.success("撤回成功")
        //关闭遮罩层
        this.swMaskService.closeMask()
        //complete:是否完成流程0:未完成,1完成 ;
        // code: 1 通过 2 退回 3 拒绝 4 撤销 
        // status: 1--审核中（此时 complete=0，code=1 或 code=2） , 2--通过（此时 complete=1. code =1）  , 3 --> 审核中（此时 complete=0， code =2）, 4--拒绝（此时 complete=1. code =3）, 5--撤销 （complete=1. code =4） , 991-->此流程为删除流程或修改流程，且点击通过按钮，业务方什么都不做（自定义表单除外）， 992-->此流程为删除流程，流程点击通过按钮且已结束， 业务方做伪删除操作 ， 999-->此流程是修改或删除流程，且点击非通过按钮
        //此时是撤销操作，流程已结束，complete=1, code=4, status=5
        let status = 6
        let res = {
          complete: data.data.completeFlag,
          code: 5,
          status:status
        }
        //如果是删除或修改流程（都是不可编辑流程），点击撤回按钮，那么status = 999
        if(this.procData.flowType == 1){ 
          res.code = 999
          res.status = 999  
        }
        // 抛出审核状态
        this.voted.emit(res);
        
        // 如果变量中配置了业务输入框在审核组件中，那么退回之后也要将此输入结果抛出给业务
        if(this.businessInputs.length){
          this.votedNodeConfigResult.emit(this.businessInputValue)
        }

        this.todos.sendAuditMessage('撤回成功') //刷新审核操作,为了通知待办页面刷新数据
        this.todos.oninitProcessToDos()  //刷新工作台待办
        //关闭当前审核页面
        if(this.openType ==1){
          this.tagServe.closeUrl();  //关闭当前标签页
        }
      } else {
        //关闭遮罩层
        this.swMaskService.closeMask()
        this.box.danger(data.msg)
      }
    })
  }

  //点击选择抄送人按钮
  selectReceiver(){
    let ids = this.receiverUsers.map(v=>v.id)
    if(this.receiver == 'allUser'){
      //如果是配置所有人
      this.create.createModal(SwAddressBookComponent,{userId:ids,headerLogo:"选择抄送人",required:2},this.selectReceiverCallback.bind(this))
    } else if(this.receiver == 'unitUser' ){
      //如果是设置本单位用户
      this.create.createModal(SwOperatorModalComponent,{headerLogo:"选择抄送人",operatorIds:'unitUser',initData:ids,required:2},this.selectReceiverCallback.bind(this))
    } else {
      let users = this.receiver.split(',')
      //如果用户的id存在,就取获取所有用户的信息,找到对应的用户, 得到找到执行人的下拉列表的数组
      this.create.createModal(SwOperatorModalComponent,{headerLogo:"选择抄送人",operatorIds:users,initData:ids,required:2},this.selectReceiverCallback.bind(this))
    } 
  }

  //选择抄送人之后的回调， data：抄送人的id 
  selectReceiverCallback(data?){
    this.receiverUsers = []
    if(data && data.length){
      data.forEach(id => {
        let i = this.allUsers.findIndex(v=>v.id == id)
        if(i != -1){
          this.receiverUsers.push(this.allUsers[i])
        }
      });
    }
    //将选中的抄送人放在变量中，审核操作时一起保存
    this.variables['noticerIds'] = data
  }

  //删除单个已选中的抄送人
  deleteReceiver(item,i){
    //删除已选中抄送人数组中的这一项
    this.receiverUsers.splice(i,1)
    this.variables['noticerIds'] = this.receiverUsers.map(v=>v.id)
  }

   //获取所有用户
   getUser(){
    let param1 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getUserService().queryList(param1).subscribe( //查询用户
      data => {
        if (data["code"] == 200) {
          let arr1 = []
          let result = data["data"]
          result.forEach(user => {
            if(user.status){
              // 查询所有用户，默认没有用户被选中
              arr1.push({id:user.userId,text:user.displayName})
            }
          });
          //所有的用户
          this.allUsers = arr1
        }
      }
    )
  }
}
